export const authRole = {
  admin: ['user', 'admin'],
  user: ['user'],
};

export const RoutePermittedLevel = {
  admin: 'admin',
  user: 'user',
};
